import i18n from 'i18n';

export const OUTBOUND_LOG_PROVIDER_I18N_KEY: Record<string, string> = {
    flask_mail: 'outbound_log_provider_flask_mail',
    ews: 'outbound_log_provider_ews',
};

export function outboundLogStatusLabel(status: string): string {
    if (status === 'sent') {
        return i18n.t('outbound_log_status_sent.text');
    }
    if (status === 'failed') {
        return i18n.t('outbound_log_status_failed.text');
    }
    return status;
}

export function outboundLogProviderLabel(provider: string): string {
    const key = OUTBOUND_LOG_PROVIDER_I18N_KEY[provider];
    return key ? i18n.t(`${key}.text`) : provider;
}
